const BaseService = require('@/services/BaseService')

const namespace = 'my-business/location'

const location = (data, cb, errorCb) => {
    BaseService.get(namespace + '/', data, cb, errorCb)
}

const media = (locationId, data, cb, errorCb) => {
    BaseService.get(namespace + '/media/' + locationId, data, cb, errorCb)
}

const reviews = (locationId, data, cb, errorCb) => {
    BaseService.get(namespace + '/reviews/' + locationId, data, cb, errorCb)
}

const insights = (locationId, data, cb, errorCb) => {
    BaseService.get(namespace + '/insights/' + locationId, data, cb, errorCb)
}

const updateLocation = (locationId, data, cb, errorCb) => {
    BaseService.put(namespace + '/' + locationId, data, cb, errorCb)
}

const updateRegularHours = (locationId, data, cb, errorCb) => {
    BaseService.put(namespace + '/hours/regular/' + locationId, data, cb, errorCb)
}

const updateSpecialHours = (locationId, data, cb, errorCb) => {
    BaseService.put(namespace + '/hours/special/' + locationId, data, cb, errorCb)
}
export {
    location,
    media,
    reviews,
    insights,
    updateLocation,
    updateRegularHours,
    updateSpecialHours
}
